<section class="container">
  <div class="alert alert-info container"
    *ngIf="!consultasOperacaoScr || !consultasOperacaoScr.length; else consultasOperacaoSCR">
    Nenhum registro encontrado.
  </div>
  <ng-template #consultasOperacaoSCR>
    <bn-paginacao [total]="countConsulta" [tamanhoPagina]="atributosPaginacaoAbaConsultaBacen.pageSize"
      [numPagina]="atributosPaginacaoAbaConsultaBacen.page" [opcoesTamanhoPagina]="opcoesPaginacaoAbaConsultaBacen">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-dataBase" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataBase'"
                  [nomeAtributoExibicao]="'Data Base'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-numeroIpoc'" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'numeroIpoc'" [nomeAtributoExibicao]="'IPOC'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
                <th id="col-tipoIPOC'" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoIPOC'" [nomeAtributoExibicao]="'Tipo de IPOC'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-dataEnvio" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'"
                  [nomeAtributoExibicao]="'Data da Consulta'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-dataRetorno" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataRetorno'"
                  [nomeAtributoExibicao]="'Data do Retorno do BACEN'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-situacaoConsulta" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'situacaoConsulta'"
                  [nomeAtributoExibicao]="'Situação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-tipo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoConsulta'"
                  [nomeAtributoExibicao]="'Tipo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let consulta of listaConsulta">
              <td>{{consulta.dataBase +'-01'| date: 'MM/yyyy' }}</td>
              <td>{{consulta.numeroIpoc}}</td>
              <td>{{consulta.tipoIPOC}}</td>
              <td>{{consulta.dataEnvio | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{consulta.dataRetorno | date: 'dd/MM/yyyy'}}</td>
              <td>{{retornaLabelSituacao(consulta.situacaoConsulta)}}</td>
              <td>{{retornaLabelTipoConsulta(consulta.tipoAcao)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </ng-template>
</section>
